import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./HotelModifyNew.css";
import { CiLocationOn } from "react-icons/ci";
import { BiSolidOffer } from "react-icons/bi";
import { Link } from "react-router-dom";
import HotelListSkeleton from "./HotelListSkeleton";
import FlightListSkeleton from "../../Flight/FlightList/FlightListSkeleton";
import HotelLoader from "../HotelLoader/HotelLoader";
import HotelNotFound from "../HotelNotFound/HotelNotFound";
import HotelSkeleton from "./HotelSkeleton";
import HotelImagesGallery from "./HotelImagesPopup";
import { FaStar } from "react-icons/fa";

function HotelListingModifyNew({ loading , hotel}) {
  const [hotelViewBtn, setHotelViewBtn] = useState(null);
  const navigate = useNavigate();
    const[showGallary, setShowGallery] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedHotelName, setSelectedHotelName] = useState("");
    const handleImageClick = (images, name) => {
  setSelectedImages(images);
  setSelectedHotelName(name);
  setShowGallery(true);
};

  const handleViewButtonClick = (hotelId) => {

    localStorage.setItem("hotelId", hotelId);
    setHotelViewBtn(hotelId);
    navigate("/hoteldetailsmain");
  };
  
  return (
    <>
      {loading ? (
        <HotelSkeleton />
      ) :
      hotel && hotel.length !== 0 ? (
        <div>
          {hotel.map((item) => (
            <div className="hotelListingstyling">
              <div className="hotelListingstyling-Container">
                <Row>
                 <Col md={4} className="hotelListingstyling-img">
                    <div
                      className="main-image-container"
                      style={{ position: "relative" }}
                    >
                      <img
                        src={
                          item.HotelImage ? item.HotelImage : "https://www.hogastjob.com/_Resources/Static/Packages/Hogast.Jobportal/images/company-placeholder.jpg"
                        }
                        alt=""
                        style={{
                          borderRadius: "5px",
                          height:
                            item.HotelImages && item.HotelImages[0]
                              ? window.innerWidth < 768
                                ? "190px"
                                : "150px"
                              : "235px",
                          // height: window.innerWidth < 768 ? "190px" : "150px",
                          objectFit: "cover",
                          objectPosition: "center center",
                          width: "100%",
                          cursor: "pointer",
                        }}
                        onClick={() => handleImageClick(item.HotelImages, item.name)}
                      />
                      {item.HotelImages && item.HotelImages.length > 1 && (
                        <div className="image-gallery-indicator">
                          <span className="gallery-count">
                            +{item.HotelImages.length - 1}
                          </span>
                        </div>
                      )}
                    </div>

                    {item.HotelImages && item.HotelImages.length > 1 && (
                      <div className="imgcolmns_hotel">
                        {item.HotelImages[1] && (
                          <span className="inrimgsec">
                            <img
                              alt="Thumb Img"
                              src={item.HotelImages[1]}
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleImageClick(item.HotelImages, item.name)
                              }
                            />
                          </span>
                        )}

                        {item.HotelImages[2] && (
                          <span className="inrimgsec ng-star-inserted">
                            <img
                              alt="Thumb Img"
                              src={item.HotelImages[2]}
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleImageClick(item.HotelImages, item.name)
                              }
                            />
                          </span>
                        )}

                        {item.HotelImages[3] && (
                          <span className="inrimgsec ng-star-inserted">
                            <img
                              src={item.HotelImages[3]}
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleImageClick(item.HotelImages, item.name)
                              }
                            />
                          </span>
                        )}

                        {item.HotelImages[4] && (
                          <span className="inrimgsec ng-star-inserted">
                            <img src={item.HotelImages[4]} />
                            <span
                              className="vwallimg"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleImageClick(item.HotelImages, item.name)
                              }
                            
                            >
                              View All
                            </span>
                          </span>
                        )}
                      </div>
                    )}
                  </Col>
                  <Col md={5} className="hotelListingstyling-img">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div className="AltAccoRatingsRenderer-styles__HotelTag-sc-614b7d7a-0 fAFCux">
                        <div className="AltAccoRatingsRenderer-styles__HotelStarRating-sc-614b7d7a-1 gWfoeC">
                          <span>{item.HotelRating}</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 17 16"
                            width="1rem"
                            height="1rem"
                            margin="0 0.2rem 0 0"
                            className="HappyRatingStarIcon-sc-934f1d6d-0 huwVyb"
                          >
                            <path
                              fillRule="evenodd"
                              d="m8.172 13.282 3.964 2.434c.726.446 1.614-.213 1.423-1.047l-1.05-4.577 3.505-3.084c.64-.562.296-1.629-.545-1.696l-4.613-.398L9.051.589c-.325-.785-1.432-.785-1.757 0L5.489 4.904l-4.613.398C.036 5.37-.31 6.436.33 6.999l3.505 3.083-1.05 4.577c-.191.834.697 1.494 1.423 1.048l3.963-2.425z"
                            />
                          </svg>
                        </div>
                        <span className="AltAccoRatingsRenderer-styles__PropertyLabel-sc-614b7d7a-2 gPwZKh">
                          Hotel
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        flexWrap: "nowrap",
                      }}
                    >
                      <div
                        className="hotelListingstyling-name"
                        title={item.HotelName}
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "300px",
                        }}
                      >
                        {item.HotelName}
                      </div>

                      {/* <div
                        className="rating-score"
                        style={{ fontSize: "15px", whiteSpace: "nowrap" }}
                      >
                        {[...Array(5)].map((_, index) => (
                          <span
                            key={index}
                            style={{
                              color:
                                index < Number(item.star_rating)
                                  ? "#FFD700"
                                  : "#ccc",
                            }}
                          >
                            ★
                          </span>
                        ))}
                      </div> */}
                    </div>

                    <div className="hotel-Address">
                      {/* <CiLocationOn /> <span>{item.city},{item.country}</span> */}
                      <CiLocationOn />{" "}
                      <span title={item.HotelAddress?.address}>{item.HotelAddress?.address}</span>
                    </div>
                    <div className="Amenties_and_Freecancellation">
                      {/* <div>
                        {[
                          ...new Set(
                            item.Rooms.map((room) =>
                              room.Name[0].replace(/['"]+/g, "").trim()
                            )
                          ),
                        ].map((uniqueName, index) => {
                          const parts = uniqueName
                            .split(",")
                            .map((s) => s.trim());
                          return (
                            <div className="amenities">
                              {parts.map((part, i) => (
                                <div className="free_amenities">{part}</div>
                              ))}
                            </div>
                          );
                        })}
                      </div> */}
           <div className="amenities">
  {(() => {
    // Extract unique room amenities
    const uniqueAmenities = [
      ...new Set(
        item.Rooms.map((room) =>
          room.RoomInfo?.[0]?.RoomCategory.replace(/['"]+/g, "").trim()
        )
      ),
    ];

    // Get last room's data
    const lastAmenityString = uniqueAmenities[uniqueAmenities.length - 1];
    const lastParts = lastAmenityString
      ? lastAmenityString.split(",").map((s) => s.trim())
      : [];

    const lastFirstTwo = lastParts.slice(0, 2);
    const lastRemaining = lastParts.slice(2);

    // Prepare other rooms data for & more hover
    const otherAmenities = uniqueAmenities.slice(0, -1);

    return (
      <>
        <div className="amenitiesss">
          {lastFirstTwo.map((part, i) => (
            <div className="free_amenities" key={i}>
              {part}
            </div>
          ))}
        </div>

        {(lastRemaining.length > 0 || otherAmenities.length > 0) && (
          <div className="more-container">
            <span
              className="PersuasionTextUI__PersuasionTextWrapperSpan-sc-33168a02-1 bdcGAt"
              style={{
                color: "rgb(34, 118, 227)",
                fontSize: "12px",
                cursor: "pointer",
              }}
            >
              &amp; more
            </span>

            <ul className="more-list">
              {/* Show remaining parts of last room */}
              {lastRemaining.map((part, j) => (
                <div
                  className="HoverPersuasion-styles__HoverCard-sc-236c8fc9-1 eTDoWQ"
                  key={`last-${j}`}
                >
                  <div className="HoverPersuasion-styles__HoverHeader-sc-236c8fc9-2 nfcIc">
                    <div className="PersuasionTextWithImageUI__PersuasionTextWrapperDiv-sc-1663bfa1-0 cDtVtC">
                      <span style={{ fontSize: "12px" }}>{part}</span>
                    </div>
                  </div>
                </div>
              ))}

              {/* Show all other rooms data */}
              {otherAmenities.map((amenityString, index) => {
                const parts = amenityString
                  .split(",")
                  .map((s) => s.trim());

                return (
                  <div
                    className="HoverPersuasion-styles__HoverCard-sc-236c8fc9-1 eTDoWQ"
                    key={`other-${index}`}
                  >
                    {parts.map((part, j) => (
                      <div
                        className="HoverPersuasion-styles__HoverHeader-sc-236c8fc9-2 nfcIc"
                        key={j}
                      >
                        <div className="PersuasionTextWithImageUI__PersuasionTextWrapperDiv-sc-1663bfa1-0 cDtVtC">
                          <span style={{ fontSize: "12px" }}>{part}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })}
            </ul>
          </div>
        )}
      </>
    );
  })()}
</div>


                      {/* <div className="amenities">
                       
                        <div className="free_amenities">Couple Friendly</div>
                        <div className="free_amenities">Local IDs Accepted</div>
                      </div> */}
                      <div className="hotel-freecancellation">
                        {/* <img
                          src="/images/checkmark.png"
                          alt=""
                          style={{ width: "16px" }}
                        /> */}
                        {/* {" "}
                       {item.Rooms[0].IsRefundable === true ? "Refundable"  : "Non-Refundable"} */}
                        {item.Rooms[0].RoomInfo[0].MealBasis}
                      </div>
                    </div>
                    { /*  <div
                      className="PersuasionTextWithImageUI__PersuasionTextWrapperDiv-sc-1663bfa1-0 cDtVtC"
                      style={{ color: "rgb(255, 109, 56)" }}
                    >
                      <img
                        src="https://go-assets.ibcdn.com/u/GI/images/1720953427381-coupleFreindlyV2.png"
                        alt=""
                        data-testid=""
                        loading="lazy"
                        style={{
                          width: "15px",
                          height: "15px",
                          fill: "rgb(255, 109, 56)",
                          marginRight: "5px",
                        }}
                      />
                      <span style={{ fontSize: "12px" }}>Couple Friendly</span>
          </div> */ }


                    <div className="PersuasionsUnif-styles__PersuasionUIElementsWrapper-sc-984d18fd-0 kpiDMy">
                      <img
                        src="https://gos3.ibcdn.com/Inclusion_Icon_Revamped_SRP-1673507159.png"
                        alt=""
                        data-testid=""
                        loading="lazy"
                        style={{
                          width: "15px",
                          height: "15px",
                          fill: "rgb(70, 72, 77)",
                          marginRight: "5px",
                        }}
                      />
                      <span
                        className="PersuasionTextUI__PersuasionTextWrapperSpan-sc-33168a02-1 bdcGAt"
                        style={{ color: "rgb(70, 72, 77)", fontSize: "12px" }}
                      >
                        {item.Rooms[0]?.IsRefundable === true
                          ? "Refundable"
                          : "Non-Refundable"}
                      </span>
                    </div>
                    <div className="PersuasionsUnif-styles__PersuasionUIElementsWrapper-sc-984d18fd-0 kpiDMy">
                      <img
                        src="https://gos3.ibcdn.com/Inclusion_Icon_Revamped_SRP-1673507159.png"
                        alt=""
                        data-testid=""
                        loading="lazy"
                        style={{
                          width: "15px",
                          height: "15px",
                          fill: "rgb(70, 72, 77)",
                          marginRight: "5px",
                        }}
                      />
                      <span
                        className="PersuasionTextUI__PersuasionTextWrapperSpan-sc-33168a02-1 bdcGAt"
                        style={{ color: "rgb(70, 72, 77)", fontSize: "12px" }}
                      >
                        {item.Rooms[0].RoomInfo[0].MealBasis}
                      </span>
                    </div>

                   
                  </Col>
                  <Col
                    md={3}
                    className="hotelListingstyling-img hotelListingstyling_hotelRatings"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <div>
                      <div className="hotel-numberic-ratingMain">
                        <div className="hotel-numberic-rating">
                          
                          <div className="rating-score rating-score-inNum">
                            {item.HotelRating}
                          </div>
                        </div>
                        <div>
                          <div className="cross-pricing">$ {item.Rooms[0]?.PublishedFare}</div>
                          <div className="real-pricing">
                            ₹ {Math.round(item.Rooms[0].PublishedFare)}{" "}
                          </div>
                          { /*  <div className="hotel-taxesFees">
                            + ₹ {Math.round(item.Rooms[0].TotalTax)} Taxes &
                            fees
          </div> */ }
                         {/*  <div
                            className="hotel-taxesFees"
                            style={{ color: "#737373" }}
                          >
                            Per Night
                          </div>
                          <div
                            className="hotel-freecancellation zeroBooking"
                            style={{ textAlign: "right" }}
                          >
                            <img
                              src="/images/checkmark.png"
                              alt=""
                              style={{ width: "16px" }}
                            />{" "}
                            Book with ₹0
                          </div> */}
                        </div>
                      </div>
                      {/* <div className="hotel-coupon hotel-couponDouble">
                          <div className="">
                            <BiSolidOffer className="hotelcouponcode_icon" />
                            TRIPGOHOTELS Discount Applied
                          </div>
                        </div> */}
                      <Link to="/hoteldetailsmain">
                        <button
                          onClick={() =>
                            handleViewButtonClick(item.id)
                          }
                          className="hotel-viewRoom-btn"
                        >
                          View Room
                        </button>
                      </Link>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          ))}
		  
		   <HotelImagesGallery
 show={showGallary}
    onClose={() => setShowGallery(false)}
    images={selectedImages} 
    name={selectedHotelName}
/>
        </div>
      ) : (
        // <> <HotelListSkeleton/> <HotelListSkeleton/> <HotelListSkeleton/></>
        // <HotelLoader/>
        <HotelNotFound />
      )}
    </>
  );
}

export default HotelListingModifyNew;
